import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::submit
* @see Http/Controllers/Tools/Image/CropImageController.php:22
* @route '/{locale}/tools/image/crop'
*/
export const submit = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

submit.definition = {
    methods: ["post"],
    url: '/{locale}/tools/image/crop',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::submit
* @see Http/Controllers/Tools/Image/CropImageController.php:22
* @route '/{locale}/tools/image/crop'
*/
submit.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return submit.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::submit
* @see Http/Controllers/Tools/Image/CropImageController.php:22
* @route '/{locale}/tools/image/crop'
*/
submit.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::submit
* @see Http/Controllers/Tools/Image/CropImageController.php:22
* @route '/{locale}/tools/image/crop'
*/
const submitForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Image\CropImageController::submit
* @see Http/Controllers/Tools/Image/CropImageController.php:22
* @route '/{locale}/tools/image/crop'
*/
submitForm.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

submit.form = submitForm

const crop = {
    submit: Object.assign(submit, submit),
}

export default crop